export default "/assets/website/images/hero-globe.jpeg?f09cec66e7da058934942c0645b67b58";